import { render, staticRenderFns } from "./resetPassword.vue?vue&type=template&id=5201e7bd&scoped=true"
import script from "./resetPassword.vue?vue&type=script&lang=js"
export * from "./resetPassword.vue?vue&type=script&lang=js"
import style0 from "./resetPassword.vue?vue&type=style&index=0&id=5201e7bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5201e7bd",
  null
  
)

export default component.exports